import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/category/importer/categoryImporterActions'

export default importerReducers(actions)
